import React, { useEffect, useRef } from "react";
import { PICKABLE_COLUMNS, TableColumnField, toggleTableColumn } from "./productTableColumns";
import { PlIcon } from "./plIcons";

/** "Columns" button + "Show columns" menu (design D05). */
const ProductColumnMenu = ({
  shown,
  onChange,
  open,
  onOpenChange,
}: {
  shown: TableColumnField[];
  onChange: (next: TableColumnField[]) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const wrapRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) onOpenChange(false);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onOpenChange(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onOpenChange]);

  return (
    <div className="pl-colmenu" ref={wrapRef}>
      <button
        type="button"
        className={`pl-btn${open ? " is-pressed" : ""}`}
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        <PlIcon name="cols" />
        Columns
      </button>
      {open ? (
        <div className="pl-menu pl-colmenu__panel" role="group" aria-label="Show columns">
          <div className="pl-menu__h">Show columns</div>
          {PICKABLE_COLUMNS.map((column) => {
            const on = shown.includes(column.field);
            return (
              <label key={column.field} className="pl-menu__item pl-ck">
                <input type="checkbox" checked={on} onChange={() => onChange(toggleTableColumn(shown, column.field))} />
                <span className={`pl-ck__box${on ? " is-on" : ""}`} aria-hidden="true" />
                <span className="pl-grow">{column.label}</span>
              </label>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ProductColumnMenu;
